import { memo } from 'react';

import { ShareDesignImageButton } from '~/components/ShareModal/components/ShareDesignImageButton';
import { useShareBoardDesign } from '~/components/SharePrivateBoardModal/ShareBoardDesignProvider';

/** Custom-logo picker (share-link `customLogo` write), bound to the board design context. */
export const ShareBoardDesignLogoButton = memo(() => {
  const {
    brandingDisabled,
    brandCustomizationEnabled,
    handleClearLogo,
    handleSelectLogo,
    hasStoredLogo,
    logoBrandOptions,
    logoSrc,
    selectedLogoBrandOptionId,
  } = useShareBoardDesign();

  return (
    <ShareDesignImageButton
      data-testid="SHARE_BOARD_DESIGN_LOGO_ROW"
      disabled={brandingDisabled}
      emptyLabel="Choose logo"
      hasValue={hasStoredLogo}
      imageSrc={logoSrc}
      onClear={handleClearLogo}
      onSelect={handleSelectLogo}
      options={logoBrandOptions}
      selectedOptionId={selectedLogoBrandOptionId}
      selectModalConfirmLabel="Use as logo"
      selectModalTitle="Select a logo"
      selectTestId="SHARE_BOARD_DESIGN_LOGO_SELECT"
      showUpsell={!brandCustomizationEnabled}
    />
  );
});

ShareBoardDesignLogoButton.displayName = 'ShareBoardDesignLogoButton';
